import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CustomerRow,
    WB_ModelCompareRelationshipRow,
    WB_ModelCompareRow,
    WB_ModelingSessionCustRRow,
    WB_ModelingSessionRow,
    WB_ModelRow,
    WB_ModelingSessionProdRRow,
    WB_ProductGroupRow,
    WB_FinishedProductRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbModelCompare,} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Model_Compare,
    esWB_Model_Compare_Relationship,
    esWB_Modeling_Session,
    esWB_Modeling_Session_Coeff_Grp,
    esWB_Modeling_Session_El,
    esWB_Modeling_Session_ConstantR,
    esWB_Modeling_Session_ConstantFR,
    esWB_Modeling_Session_Trial,
    esWB_Modeling_Session_Range,
    esWB_Modeling_Session_Trial_Metric,
    esWB_Model,
    esWB_Model_Coefficient,
    esWB_Model_Term_Relationship,
    esWB_Modeling_Session_AffinitySet_Relationship,
    esWB_Modeling_Session_Coeff_Rule,
    esWB_Modeling_Session_Observation,
    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship,
    esWB_Modeling_Session_Tag_RuleR,
    esWB_Modeling_Session_Reference_Predictor_Relationship,
    esWB_Modeling_Session_Log,
    esWB_Modeling_Session_ElCR,
    esWB_Modeling_Session_ElR,
    esWB_Modeling_Session_Cannibalization_Type_Relationship,
    esWB_Model_Cannibalization_Relationship,
    esWB_Model_Predictor,
    esWB_Customer_Hierarchy,
    esWB_Product_Hierarchy,
    esWB_Period_Hierarchy,
    esWB_Period_Type, esWB_Modeling_Session_TermR, esWB_Modeling_Session_Reference_Relationship, esWB_Model_Function
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {IModelCompareSessionChangedEvent, IModelCompareSessions} from "../PA.Model.Core/PA.Model.IF.Aspects";


export class ModelCompareBO implements IBusinessObject,
    IModelCompareSessions {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ModelCompare: WB_ModelCompareRow;

    _ModelingSessionsChanged: BehaviorSubject<ModelCompareBO>

    _dctCustomerRowLoadedById: { [id: number]: WB_CustomerRow }
    _dctPrdGrpRowLoadedById: { [id: number]: WB_ProductGroupRow }
    _dctPrdRowLoadedById: { [id: number]: WB_FinishedProductRow }

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Model Compare'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ModelCompare = null;

        this._ModelingSessionsChanged = new BehaviorSubject<ModelCompareBO>(undefined)
        this._dctPrdGrpRowLoadedById = {}
        this._dctCustomerRowLoadedById = {}
        this._dctPrdRowLoadedById = {}

        this.IModelCompareSessions_init()
    }

    get WB_ModelCompare(): WB_ModelCompareRow {
        return this.drWB_ModelCompare;
    }

    get PrimaryModelingSession(): WB_ModelCompareRelationshipRow {
        return _.first(_.filter(this.WB_ModelCompare.WB_ModelCompareRRows, aRow => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))
    }

    get PrimaryProductGroups(): WB_ProductGroupRow[] {
        return _.values(this._dctPrdGrpRowLoadedById)
    }

    get PrimaryProducts(): WB_FinishedProductRow[] {
        return _.values(this._dctPrdRowLoadedById)
    }

    get PrimaryCustomers(): WB_CustomerRow[] {
        return _.values(this._dctCustomerRowLoadedById)
    }

    //<editor-fold desc = "IBusinessObject operations">
    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Model Compare");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            this.dbContext.createRecordWithKey(esWB_Model_Compare)
                .then((newModelCompareRow: WB_ModelCompareRow) => {
                    newModelCompareRow.setDefaults();
                    newModelCompareRow.cif.COMPARE_TYPE = "ModelCompare"
                    self.drWB_ModelCompare = newModelCompareRow;
                    self.dbContext.add(esWB_Model_Compare, newModelCompareRow);
                    self.Identity.setAll(self.WB_ModelCompare.cif.WB_MODELCOMPARE_ID, self.WB_ModelCompare.cif.MODEL_COMPARE_ID, self.WB_ModelCompare.cif.MODEL_COMPARE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ModelCompare, 'WB_MODELCOMPARE_ID', 'MODEL_COMPARE_ID', 'MODEL_COMPARE_NAME');
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Model Compare already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Model Compare.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ModelCompareBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = ModelCompareBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newModelCompareRow: any = recordResolver.get(esWB_Model_Compare, anId);

                    if (_.isEmpty(newModelCompareRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_ModelCompare = newModelCompareRow;
                    self.Identity.setAll(self.WB_ModelCompare.cif.WB_MODELCOMPARE_ID, self.WB_ModelCompare.cif.MODEL_COMPARE_ID, self.WB_ModelCompare.cif.MODEL_COMPARE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ModelCompare, 'WB_MODELCOMPARE_ID', 'MODEL_COMPARE_ID', 'MODEL_COMPARE_NAME');
                })
                .then((ignore: any) => {
                    return self.setModelCompareScope(-1)
                })
                .then(() => {
                    return self.IModelCompareSessions_OnLoadComplete()
                })
                .then((ignore: any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        if (this._bIsLoaded) {
            return ASync.resolve(this)
        }
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_ModelCompare.cif.MODEL_COMPARE_NAME + "(" + self.WB_ModelCompare.cif.MODEL_COMPARE_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Model Compare.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbModelCompare = <IwbModelCompare>self.drWB_ModelCompare;
        this.SaveProgressProvider.start("Saving " + wbModelCompare.MODEL_COMPARE_NAME + "(" + wbModelCompare.MODEL_COMPARE_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Model Compare.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            saveFunction(esWB_Model_Compare, self.drWB_ModelCompare, {})
                .then((ignored) => {
                    let tasks: Promise<any>[] = [];

                    tasks.push(saveFunction(esWB_Model_Compare, self.drWB_ModelCompare));
                    tasks.push(saveFunction(esWB_Model_Compare_Relationship, self.drWB_ModelCompare.WB_ModelCompareRRows));
                    return Promise.all(tasks);
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    reject(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbModelCompare = <IwbModelCompare>self.drWB_ModelCompare;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbModelCompare.MODEL_COMPARE_NAME + "(" + wbModelCompare.MODEL_COMPARE_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ModelCompare.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


//<editor-fold desc = "Modeling Session operations">
    _ModelCompareSessionCollectionChanged: BehaviorSubject<IModelCompareSessions>;
    _ModelCompareSessionPropertyChanged: BehaviorSubject<IModelCompareSessionChangedEvent>;

    IModelCompareSessions_init(): void {

        this._ModelCompareSessionCollectionChanged = new BehaviorSubject<IModelCompareSessions>(undefined);
        this._ModelCompareSessionPropertyChanged = new BehaviorSubject<IModelCompareSessionChangedEvent>(undefined);

    }

    private IModelCompareSessions_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(self.WB_ModelCompare.WB_ModelCompareRRows, (aRow) => {
                aRow.setupOnChangeEvents([], self.IModelCompareSession_onRecordChange.bind(self), self)
            })
            resolve()
        })
    }


    private IModelCompareSession_onRecordChange(record: WB_ModelCompareRelationshipRow, propertyName: string, propertyValue: any, options: ModelCompareBO) {
        this.ModelCompareSessionPropertyChanged.next({
            ModelCompareBO: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    get ModelCompareSessionPropertyChanged(): BehaviorSubject<IModelCompareSessionChangedEvent> {
        return this._ModelCompareSessionPropertyChanged
    }


    get ModelingSessionsChanged(): BehaviorSubject<IModelCompareSessions> {
        return this._ModelCompareSessionCollectionChanged
    }

    async addModelingSession(aWB_Id: number, options?: any): Promise<WB_ModelCompareRelationshipRow> {
        const self = this;


        let recordResolver = ModelCompareBO.createModelingSessionRecordResolver({dbContext: self.dbContext})

        let query: any = {WB_MODELING_SESSION_ID: aWB_Id}
        let arrModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await recordResolver.queryAllWithRelationships(esWB_Modeling_Session, query)

        if (_.isEmpty(arrModelingSession))
            return

        let aMSRecord = _.first(arrModelingSession)

        let aNewRow: WB_ModelCompareRelationshipRow = <any>await self.dbContext.createRecordWithKey(esWB_Model_Compare_Relationship)
        let defaultColor = _.first(_.difference(['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#42d4f4', '#f032e6', '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#000075', '#a9a9a9', '#ffffff', '#000000'], _.map(_.filter(self.drWB_ModelCompare.WB_ModelCompareRRows, aRow => aRow.isActive), 'PLOT_DATA_COLOR')))
        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELCOMPARE_ID = self.drWB_ModelCompare.cif.WB_MODELCOMPARE_ID;
        aNewRow.cif.WB_MODELING_SESSION_ID = aWB_Id
        aNewRow.cif.PRIMARY_IND = (options.bPrimary) ? '1' : '0'
        aNewRow.cif.PLOT_DATA_COLOR = defaultColor

        aNewRow.WB_ModelingSessionRow = aMSRecord
        aNewRow.setupOnChangeEvents([], self.IModelCompareSession_onRecordChange.bind(self), self)

        self.dbContext.add(esWB_Model_Compare_Relationship, aNewRow)

        if (options.bPrimary)
            await self.setModelCompareScope(aWB_Id)

        self.ModelingSessionsChanged.next(self)

        return (aNewRow)

    }

    removeModelingSession(aWB_MODELCOMPARER_IDs: number[], options?: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            let keyByIds = _.keyBy(aWB_MODELCOMPARER_IDs, anId => anId)

            _.forEach(self.drWB_ModelCompare.WB_ModelCompareRRows, (aRow: WB_ModelCompareRelationshipRow) => {
                if (aRow.isActive && (aRow.cif.WB_MODELCOMPARER_ID in keyByIds)) {
                    aRow.markDeleted()
                }
            })

            //check if the primary modeling session has been deleted -> if yes -> make that primary and reset the scope

            let activeModelRRows: WB_ModelCompareRelationshipRow[] = _.filter(self.drWB_ModelCompare.WB_ModelCompareRRows,
                (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive)
            let modelCompareR: WB_ModelCompareRelationshipRow = _.first(_.filter(activeModelRRows,
                (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))
            if (_.isUndefined(modelCompareR) && activeModelRRows.length > 0) {
                activeModelRRows[0].cif.PRIMARY_IND = '1'
            }

            // this.resetModelCompareScope()

            self.setModelCompareScope(-1)
                .then(() => {
                    self.ModelingSessionsChanged.next(self)
                    resolve()
                })
                .catch((err) => {
                    console.log(err)
                    resolve()
                })
        })

    }

    setModelCompareScope(aWBId: number): Promise<void> {
        const self = this;

        return new Promise<void>(async (resolve, error) => {

                try {
                    if (aWBId == -1) {
                        //fetch the primary modeling session
                        let modelCompareR: WB_ModelCompareRelationshipRow = _.first(_.filter(self.drWB_ModelCompare.WB_ModelCompareRRows,
                            (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))

                        if (_.isUndefined(modelCompareR)) {
                            //self.resetModelCompareScope()
                            resolve()
                            return
                        } else
                            aWBId = modelCompareR.cif.WB_MODELING_SESSION_ID
                    }

                    let recordResolver = ModelCompareBO.createModelingSessionRecordResolver({dbContext: self.dbContext})
                    let query: any = {WB_MODELING_SESSION_ID: aWBId}
                    let arrModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await recordResolver.queryAllWithRelationships(esWB_Modeling_Session, query)

                    let primaryRecord: WB_ModelingSessionRow = arrModelingSession[0]
                    let modelRow: WB_ModelRow = primaryRecord.WB_ModelRow

                    //set model resolution
                    self.WB_ModelCompare.cif.WB_ENTITY_ID_PERIOD = primaryRecord.cif.WB_ENTITY_ID_PERIOD
                    self.WB_ModelCompare.cif.WB_ENTITY_ID_CUSTOMER = primaryRecord.cif.WB_ENTITY_ID_CUSTOMER
                    self.WB_ModelCompare.cif.WB_ENTITY_ID_PRODUCT = primaryRecord.cif.WB_ENTITY_ID_PRODUCT
                    self.WB_ModelCompare.cif.WB_SALESORG_ID = primaryRecord.cif.WB_SALESORG_ID

                    if (primaryRecord.cif.WB_CUSTH_ID != self.WB_ModelCompare.cif.WB_CUSTH_ID) {
                        let custHRow = await self.dbContext.find(esWB_Customer_Hierarchy, primaryRecord.cif.WB_CUSTH_ID)
                        self.WB_ModelCompare.WB_CustomerHierarchyRow = custHRow
                        self.WB_ModelCompare.cif.WB_CUSTH_ID = primaryRecord.cif.WB_CUSTH_ID
                    }

                    if (primaryRecord.cif.WB_PRDH_ID != self.WB_ModelCompare.cif.WB_PRDH_ID) {
                        let prodHRow = await self.dbContext.find(esWB_Product_Hierarchy, primaryRecord.cif.WB_PRDH_ID)
                        self.WB_ModelCompare.WB_ProductHierarchyRow = prodHRow
                        self.WB_ModelCompare.cif.WB_PRDH_ID = primaryRecord.cif.WB_PRDH_ID
                    }

                    if (primaryRecord.cif.WB_PERIODH_ID != self.WB_ModelCompare.cif.WB_PERIODH_ID) {
                        let periodHRow = await self.dbContext.find(esWB_Period_Hierarchy, primaryRecord.cif.WB_PERIODH_ID)
                        self.WB_ModelCompare.WB_PeriodHierarchyRow = periodHRow
                        self.WB_ModelCompare.cif.WB_PERIODH_ID = primaryRecord.cif.WB_PERIODH_ID
                    }

                    //set the dates
                    self.WB_ModelCompare.cif.START_DT = primaryRecord.cif.START_DT
                    self.WB_ModelCompare.cif.END_DT = primaryRecord.cif.END_DT
                    self.WB_ModelCompare.cif.HOLDOUT_START_DT = primaryRecord.cif.HOLDOUT_START_DT
                    self.WB_ModelCompare.cif.HOLDOUT_END_DT = primaryRecord.cif.HOLDOUT_END_DT

                    //set primary customers
                    let arrCustomers: WB_CustomerRow[] = _.map(
                        _.filter(primaryRecord.WB_ModelingSessionCustRRows, (aRow: WB_ModelingSessionCustRRow) => aRow.isActive),
                        (aCustRRow: WB_ModelingSessionCustRRow) => aCustRRow.WB_CustomerRow)
                    self._dctCustomerRowLoadedById = arrCustomers

                    //set Primary products or productGroups  - depending on the model product type
                    if (modelRow.cif.PRODUCT_TYPE == "Product") {
                        let arrProducts: WB_FinishedProductRow[] = _.map(
                            _.filter(primaryRecord.WB_ModelingSessionProdRRows, (aRow: WB_ModelingSessionProdRRow) => aRow.isActive),
                            (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.WB_ProductRow)
                        self._dctPrdRowLoadedById = arrProducts
                    } else {
                        let arrProductGrps: WB_ProductGroupRow[] = _.map(
                            _.filter(primaryRecord.WB_ModelingSessionProdRRows, (aRow: WB_ModelingSessionProdRRow) => aRow.isActive),
                            (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.WB_ProductGroupRow)
                        self._dctPrdGrpRowLoadedById = arrProductGrps
                    }


                    resolve()
                } catch (err) {
                    error(err)
                }
            }
        )
    }

    resetModelCompareScope(): void {
        const self = this;

        //set model resolution
        self.WB_ModelCompare.cif.PRODUCT_TYPE = ""
        self.WB_ModelCompare.cif.CUSTOMER_LEVEL = ""
        self.WB_ModelCompare.cif.PRODUCT_LEVEL = ""
        self.WB_ModelCompare.cif.WB_CUSTH_ID = 0
        self.WB_ModelCompare.cif.WB_PRDH_ID = 0
        self.WB_ModelCompare.cif.WB_PERIODH_ID = 0
        self.WB_ModelCompare.cif.WB_PERIODM_ID = 0

        self.WB_ModelCompare.WB_CustomerHierarchyRow.cif.WB_CUSTH_ID = 0
        self.WB_ModelCompare.WB_CustomerHierarchyRow.cif.WB_CUST_HIER_ID = ""
        self.WB_ModelCompare.WB_CustomerHierarchyRow.cif.WB_CUST_HIER_NAME = ""

        self.WB_ModelCompare.WB_ProductHierarchyRow.cif.WB_PRDH_ID = 0
        self.WB_ModelCompare.WB_ProductHierarchyRow.cif.WB_PRD_HIER_ID = ""
        self.WB_ModelCompare.WB_ProductHierarchyRow.cif.WB_PRD_HIER_NAME = ""

        self.WB_ModelCompare.WB_PeriodHierarchyRow.cif.WB_PERIODH_ID = 0
        self.WB_ModelCompare.WB_PeriodHierarchyRow.cif.WB_PERIOD_HIER_ID = ""
        self.WB_ModelCompare.WB_PeriodHierarchyRow.cif.WB_PERIOD_HIER_NAME = ""

        self.WB_ModelCompare.WB_PeriodTypeRow.cif.WB_PERIODM_ID = 0
        self.WB_ModelCompare.WB_PeriodTypeRow.cif.PERIOD_TYPE_ID = ""
        self.WB_ModelCompare.WB_PeriodTypeRow.cif.PERIOD_TYPE_NAME = ""

        //set the dates
        self.WB_ModelCompare.cif.START_DT = ""
        self.WB_ModelCompare.cif.END_DT = ""
        self.WB_ModelCompare.cif.HOLDOUT_START_DT = ""
        self.WB_ModelCompare.cif.HOLDOUT_END_DT = ""

        self._dctPrdRowLoadedById = []
        self._dctPrdGrpRowLoadedById = []
        self._dctCustomerRowLoadedById = []
    }


    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const modelCompare_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {
                [esWB_Modeling_Session]: [esWB_Model]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, modelCompare_options);

        return aRecResolver;
    }


    static createModelingSessionRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const modelingSession_options: CreateOptions = {
            standardConditions: {},
            dctExcludeHasManyNamedRelations: {
                [esWB_Modeling_Session]: [
                    esWB_Modeling_Session_El, esWB_Modeling_Session_Coeff_Grp, esWB_Modeling_Session_ConstantR,
                    esWB_Modeling_Session_ConstantFR, esWB_Modeling_Session_Trial, esWB_Modeling_Session_Range, esWB_Modeling_Session_Trial_Metric,
                    esWB_Modeling_Session_AffinitySet_Relationship, esWB_Modeling_Session_Coeff_Rule, esWB_Modeling_Session_Observation,
                    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship, esWB_Modeling_Session_Tag_RuleR, esWB_Modeling_Session_Reference_Predictor_Relationship,
                    esWB_Modeling_Session_Log, esWB_Modeling_Session_ElCR, esWB_Modeling_Session_ElR, esWB_Modeling_Session_Cannibalization_Type_Relationship,
                    esWB_Modeling_Session_TermR, esWB_Modeling_Session_Reference_Relationship
                ],
                [esWB_Model]: [esWB_Model_Coefficient, esWB_Model_Term_Relationship, esWB_Model_Cannibalization_Relationship, esWB_Model_Predictor, esWB_Model_Function]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, modelingSession_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Model_Compare, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(ModelCompareBO, "ModelCompareBO", "Model Compare")
